export default __webpack_public_path__ + "justhatched-third-screens.fbf37264.png";